"use client";

import { useTranslations } from "next-intl";

import { AviCard } from "@/components/ui/aviCard";
import { useAviList } from "@/queries";
import { useAviFilterStore } from "@/store/useAviFilterStore";

import { useFavoritesAvi } from "../queries/useFavoritesAvi";
import { AviFilterDrawer } from "./aviFilterDrawer";
import { AviFilterTags } from "./aviFilterTags";
import { ItemList } from "./itemList";

export function AviList() {
  const t = useTranslations("home");
  const applied = useAviFilterStore((state) => state.applied);
  const reset = useAviFilterStore((state) => state.reset);
  const search = useAviFilterStore((state) => state.search);
  const setSearch = useAviFilterStore((state) => state.setSearch);
  const matchMode = useAviFilterStore((state) => state.matchMode);
  const setMatchMode = useAviFilterStore((state) => state.setMatchMode);

  return (
    <ItemList
      title={t("aviList.title")}
      applied={applied}
      onResetFilters={reset}
      search={search}
      onSearchChange={setSearch}
      matchMode={matchMode}
      onMatchModeChange={setMatchMode}
      useAllQuery={useAviList}
      useFavoritesQuery={useFavoritesAvi}
      renderCard={(item, accountId, listParams) => (
        <AviCard key={item.paa_uuid} item={item} accountId={accountId} listParams={listParams} />
      )}
      FilterDrawer={AviFilterDrawer}
      FilterTags={AviFilterTags}
      loadingText={t("aviList.loading")}
      errorText={t("aviList.error")}
      emptyStateMessage={t("aviList.empty")}
    />
  );
}
